
import { faMessageExclamation } from '@fortawesome/pro-light-svg-icons'
import { useRouter } from 'next/router'

import { useTranslation } from '@flecto/translations'

import { useStoreUrl } from '../../hooks/useStoreUrl'
import { PageError } from '../PageError/PageError'

export function PageError404() {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  const router = useRouter()
  const url = useStoreUrl()

  return (
    <PageError
      icon={faMessageExclamation}
      title={t('page_404.title')}
      description={t('page_404.description')}
      actionLabel={t('page_404.action_label')}
      actionCallback={() => router.push(url)}
    />
  )
}
